import React from 'react';
import cn from 'classnames';
import { PanelGroup, Panel, PanelArrow } from '@creditflowresearch/uilib/PanelGroup';
import IconExpand from '@creditflowresearch/uilib/Icon/IconExpand';
import IconCollapse from '@creditflowresearch/uilib/Icon/IconCollapse';
import styles from '@/creditflowresearch/ui/common/components/organisms/Filters/filters.module.scss';

interface IProps {
  sectionId: string | number,
  isVisible: boolean,
  showArrow?: boolean,
  onSectionToggle: Function,
  headerComponent: React.ReactNode,
  children: React.ReactNode,
  dataTest?: string,
  wrapperClassName?: string,
  headerClassName?: string,
  contentClassName?: string,
}

const arrowPlus = (
  <PanelArrow
    icon={ IconExpand }
    arrowWrapperClassName={ styles.panelGroupFilterHeaderArrowIcon }
  />
);

const arrowMinus = (
  <PanelArrow
    isActive
    iconActive={ IconCollapse }
    arrowWrapperClassName={ styles.panelGroupFilterHeaderArrowIcon }
  />
);

function FilterSection({
  sectionId,
  isVisible,
  showArrow = true,
  headerComponent,
  children,
  dataTest,
  onSectionToggle,
  wrapperClassName,
  headerClassName,
  contentClassName,
}: IProps) {
  return (
    <PanelGroup
      activeKey={ isVisible ? String(sectionId) : '' }
      // @ts-ignore
      dataTest={ dataTest }
      onChange={ () => onSectionToggle(sectionId) }
    >
      <Panel
        id={ String(sectionId) }
        key={ sectionId }
        header={ headerComponent }
        showArrow={ showArrow }
        arrow={ arrowPlus }
        arrowActive={ arrowMinus }
        destroyOnToggle={ false }
        className={ cn(styles.panelGroupWrapper, wrapperClassName) }
        headerClass={ cn(styles.panelGroupHeader, headerClassName) }
        contentClass={ cn(styles.panelGroupContentWrapper, contentClassName) }
      >
        { children }
      </Panel>
    </PanelGroup>
  );
}

export default React.memo(FilterSection);
